<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="input" :label="textInput" required />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancel"> Fechar </v-btn>
        <v-btn color="blue darken-1" text @click="modalSubmit"> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalBox',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    textInput: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      input: '',
    };
  },
  methods: {
    init(value) {
      this.input = value;
    },
    modalSubmit() {
      this.$emit('save', this.input);
    },
    cancel() {
      this.input = '';
      this.$emit('close');
    },
  },
};
</script>